import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as style from './BulkUploadWizardError.styl';
export class BulkUploadWizardError extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { errorType, errorMessage } = this.props;
        let subMessage;
        switch (errorType) {
            case 'FILE': {
                subMessage = _jsx("p", { children: "Please review the errors and make necessary changes." });
                break;
            }
            case 'INLINE': {
                const count = this.props.errorDiffs.reduce((errorCount, diff) => errorCount + Object.keys(diff.fieldErrorMap).length, 0);
                subMessage = (_jsxs("p", { children: ["Please review these ", _jsxs("em", { children: [count, " errors"] }), " and make necessary changes."] }));
                break;
            }
        }
        const errorBody = (_jsxs("div", Object.assign({ className: "errorBody" }, { children: [_jsx("p", { children: errorMessage }), subMessage] })));
        return (_jsxs("div", Object.assign({ className: style.global }, { children: [_jsx("img", { src: require('./file_upload_error.svg'), className: "placeholderGraphic" }), _jsx("div", Object.assign({ className: "errorTitle" }, { children: "Failed to process file" })), errorBody] })));
    }
}
